/**
 * Flat discount per component product that brings a combo to exactly its price.
 * The gap between the components' individual prices and the combo price is shared
 * in proportion to each component's value, floored, with the remainder on the last
 * component — so the shares always sum to the gap. (A uniform percentage floored
 * per line can leave the cart a minor unit above the combo price.)
 */
export function comboLineDiscounts(
  items: ReadonlyArray<{ product_id: string; quantity: number; individual_price: number }>,
  comboPrice: number,
): Map<string, number> {
  const values = items.map((it) => it.quantity * it.individual_price);
  const individualTotal = values.reduce((sum, v) => sum + v, 0);
  const gap = Math.max(0, individualTotal - comboPrice);
  const shares = new Map<string, number>();
  if (gap === 0) return shares;
  let allocated = 0;
  items.forEach((it, idx) => {
    const share =
      idx === items.length - 1 ? gap - allocated : Math.floor((gap * values[idx]) / individualTotal);
    allocated += share;
    shares.set(it.product_id, (shares.get(it.product_id) ?? 0) + share);
  });
  return shares;
}
